module.exports = __webpack_public_path__ + "static/media/SunflowerIcon.b7d4c038.svg";